  // --- UI Definitions ---
  const manaColors = [
    { code: 'W', name: 'Weiß', bgColor: '#F9F7E0', textColor: '#000' },
    { code: 'U', name: 'Blau', bgColor: '#ADD8E6', textColor: '#000' },
    { code: 'B', name: 'Schwarz', bgColor: '#36454F', textColor: '#FFF' },
    { code: 'R', name: 'Rot', bgColor: '#DC143C', textColor: '#FFF' },
    { code: 'G', name: 'Grün', bgColor: '#7CFC00', textColor: '#000' },
    { code: 'C', name: 'Farblos', bgColor: '#D3D3D3', textColor: '#000' },
  ];

  const typeOptions = [
    'legendary', 'creature', 'land', 'enchantment', 'instant', 'sorcery', 'artifact', 'token', 'planeswalker'
  ];

    export { manaColors, typeOptions };